export default "__VITE_ASSET__5bIv6vVy__"